import { subSeconds } from 'date-fns'
import { formatInTimeZone } from 'date-fns-tz'
import { TreasureItem } from '../types/pBox'
import { formatSkinName } from './formatSkinName'

export const formatDate = (date: string, format = 'yyyy-MM-dd HH:mm:ss') => {
  if (!date) return ''
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  return formatInTimeZone(new Date(date), userTimeZone, format)
}

export const formatDateRange = (createTime: string, endTime: string) => {
  if (!createTime) {
    return `registration`
  }
  if (!endTime) {
    return ''
  }
  const startDate = new Date(createTime)
  const endDate = new Date(endTime)
  const endDateMinusOneSecond = subSeconds(endDate, 1)

  // 格式化为 UTC 时间
  const formattedStart = formatInTimeZone(startDate, 'UTC', 'yyyy-MM-dd HH:mm:ss')
  const formattedEnd = formatInTimeZone(endDateMinusOneSecond, 'UTC', 'yyyy-MM-dd HH:mm:ss')

  return `${formattedStart} - ${formattedEnd}`
}

export const formatStr = (seed?: string, start = 14, end = 14) => {
  if (!seed) return '***********************'
  return seed.slice(0, start) + '...' + seed.slice(-end)
}
export const formatNullStr = (seed: string | undefined | any) => {
  if (!seed) return '***********************'
  return seed
}

export const formatTreasureItem = (item: any): TreasureItem => {
  const formattedItem = {
    base: {
      groupId: item.id.toString(),
      metaId: item.id.toString(),
      prob: item.prob,
      value: item.value,
      isGold: item.isGold,
    },
    entityAttrs: {
      base: {
        exterior: item.exterior,
        marketHash: item.marketHash,
        phase: item.phase,
        rarity: item.rarity,
        siblingName: item.siblingName,
        specialty: item.specialty,
        subType: item.subType,
        type: item.type,
      },
      display: {
        desc: item.desc,
        img: item.imageUrl,
        name: item.name,
      },
    },
    ext: {},
    luckster: {
      flag: 0,
    },
  } as TreasureItem

  return formattedItem
}

export const formatPBoxDetail = (data: any) => {
  return {
    ...data,
    base: {
      ...data.base,
      version: data.base.version ?? data.base.id,
    },
    treasures: {
      items: data.treasures.map((item: any) => formatTreasureItem(item)),
    },
  }
}

export const formatUTCDate = (date: Date): string => {
  return (
    date.getUTCFullYear() +
    '-' +
    String(date.getUTCMonth() + 1).padStart(2, '0') +
    '-' +
    String(date.getUTCDate()).padStart(2, '0')
  )
}
